/**
 * Единица длины на экране (мм, см, м, дюймы), сохраняется между посещениями. Модель остаётся
 * в миллиметрах — единица нужна только подписям и полям ввода.
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { LengthUnit } from "@/shared/lib/geometry";

interface LengthUnitState {
	unit: LengthUnit;
	setUnit: (unit: LengthUnit) => void;
}

export const useLengthUnitStore = create<LengthUnitState>()(
	persist(
		(set) => ({
			unit: "mm",
			setUnit: (unit) => set({ unit }),
		}),
		{ name: "gridplanner-length-unit" },
	),
);

/** Выбранная единица длины — компонент перерисуется, когда её сменят. */
export const useLengthUnit = () => useLengthUnitStore((s) => s.unit);
